/**
 * LatestFiles — horizontally swipeable rail of the most recently added
 * published dossiers. Auto-surfaces new publications (no manual curation).
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { resolveImg, relTime, SectionHeader, HRail } from "./homeShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LatestCard = ({ d }) => (
  <Link
    to={`/topic/${d.slug}`}
    data-testid={`latest-card-${d.slug}`}
    className="group block border overflow-hidden w-[240px] md:w-[264px] hover:-translate-y-1 transition-transform duration-300"
    style={{ borderColor: "#2D2A26", background: "#0F0E12" }}
  >
    <div className="relative h-[150px] md:h-[164px] overflow-hidden" style={{ background: "#131015" }}>
      {d.image_url ? (
        <img
          src={resolveImg(d.thumb_url || d.image_url)}
          alt={d.title}
          loading="lazy"
          className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-[1.04] transition-all duration-500"
          style={{ filter: "saturate(0.75) contrast(1.05)" }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center font-display text-4xl text-[#2D2A26]">
          {(d.title || "?").charAt(0)}
        </div>
      )}
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, transparent 40%, rgba(11,10,13,0.85) 100%)" }}
      />
      {d.is_new && (
        <span
          data-testid={`latest-new-badge-${d.slug}`}
          className="absolute top-2.5 left-2.5 font-mono text-[8px] uppercase tracking-[0.3em] px-2 py-1 text-[#0B0A0D]"
          style={{ background: "#D92D20", color: "#F5F1E8" }}
        >
          NEW
        </span>
      )}
      <span className="absolute bottom-2.5 left-2.5 font-mono text-[8px] uppercase tracking-[0.3em] text-[#A39E93]">
        {d.category}
      </span>
    </div>
    <div className="p-3.5">
      <h3 className="font-heading text-[15px] leading-snug text-[#E4DFD3] group-hover:text-[#D92D20] transition-colors line-clamp-2 min-h-[38px]">
        {d.title}
      </h3>
      <div className="mt-2 flex items-center justify-between font-mono text-[9px] uppercase tracking-[0.2em] text-[#8A8377]">
        <span>Added {relTime(d.created_at)}</span>
        <span className="text-[#454038] group-hover:text-[#D92D20] transition-colors">OPEN →</span>
      </div>
    </div>
  </Link>
);

const LatestFiles = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let dead = false;
    axios.get(`${API}/home/latest`, { params: { limit: 6 }, timeout: 12000 })
      .then((r) => { if (!dead) setItems(r.data?.items || []); })
      .catch(() => {});
    return () => { dead = true; };
  }, []);

  if (!items.length) return null;
  return (
    <section data-testid="home-latest-files" style={{ background: "#0B0A0D" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-10 md:pt-20 pb-2 md:pb-4">
        <SectionHeader
          file="File 001 · New Acquisitions"
          title="Latest Files"
          subtitle="The most recent dossiers declassified into the public record."
          action="/archive"
          actionLabel="View all"
          testid="latest-files-header"
        />
        <HRail testid="latest-files-rail">
          {items.map((d) => <LatestCard key={d.slug} d={d} />)}
        </HRail>
      </div>
    </section>
  );
};

export default LatestFiles;
